import { render, staticRenderFns } from "./RischioResiduoDialog.vue?vue&type=template&id=68e9a555"
import script from "./RischioResiduoDialog.vue?vue&type=script&lang=js"
export * from "./RischioResiduoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports